import { forwardRef } from 'react';
import { Typography } from '../typography/typography';
import { clsx } from 'clsx';
import { sprinkles } from '@design-system/sprinkles.css';
import _ from 'lodash';
import {
  errorBorder,
  errorText,
  textarea,
  label,
  supportingText,
  textDisabled,
} from './textarea.css';

export type TextareaProps =
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    label?: string;
    error?: string;
    supportingText?: string;
    testId?: string;
  };

const omitKeys: Array<keyof TextareaProps> = ['supportingText', 'testId'];

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (p, ref) => (
    <div className="flex flex-col w-full" data-testid={p?.testId}>
      {p?.label ? (
        <div className={sprinkles({ display: 'flex' })}>
          <Typography
            variant="body"
            size="medium"
            className={clsx(
              label,
              p?.error && errorText,
              p?.disabled && textDisabled,
            )}
          >
            {p.label}
          </Typography>
          {p?.required ? (
            <Typography
              variant="body"
              size="medium"
              className={clsx(
                errorText,
                sprinkles({ paddingTop: 's' }),
                p?.disabled && textDisabled,
              )}
            >
              *
            </Typography>
          ) : null}
        </div>
      ) : null}
      <textarea
        {..._.omit(p, omitKeys)}
        role="textarea"
        name="ds-textarea"
        className={clsx(textarea, p?.error && errorBorder)}
        ref={ref}
        onFocus={(e) => e.target.select()}
      />
      {p?.supportingText || p?.error ? (
        <Typography
          variant="body"
          size="small"
          className={clsx(supportingText, p?.error && errorText)}
        >
          {p.error || p.supportingText}
        </Typography>
      ) : null}
    </div>
  ),
);
